import { render, staticRenderFns } from "./CotizacionMascota.vue?vue&type=template&id=2f4c7ec6&scoped=true"
import script from "./CotizacionMascota.vue?vue&type=script&lang=js"
export * from "./CotizacionMascota.vue?vue&type=script&lang=js"
import style0 from "./CotizacionMascota.vue?vue&type=style&index=0&id=2f4c7ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4c7ec6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VContainer,VRow,VTextField,VTooltip})
